export const environment = {
  production: true,
  e2e: false,
  raven: "https://d1d6da73b4bd41d3a7019cee07f53de7@sentry.bazissoft.ru/6",
};
